import { post } from 'libs/GrebbCommerceAPI/util';

export default async data => {
    return await post('/orders/cancellation', data);
};
